import React from "react";
import cns from "classnames";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { makeStyles } from "@material-ui/core/styles";
import locale from "@bonliva-crm/locale";
import { professions } from "@bonliva-crm/common";
import { ThemeType } from "@theme";

type Props = {
  options: string[];
  value: string;
  onChange: (value: string) => void;
  onNew: () => void;
  error: string;
};

export function ProfessionToggleButton(props: Props) {
  const classes = useStyles({});
  return (
    <ToggleButtonGroup
      exclusive
      value={props.value}
      className={cns(classes.toggleButtonGroup, { [classes.error]: !!props.error })}
    >
      {props.options.map((item, i) => {
        return (
          <ToggleButton
            key={i}
            className={classes.toggleButton}
            value={item}
            onClick={() => props.onChange(item)}
          >
            {professions.getProfessionDisplayName(item)}
          </ToggleButton>
        );
      })}

      <ToggleButton className={classes.toggleButton} value="new" onClick={props.onNew}>
        {props.error || locale.AddNew}
      </ToggleButton>
    </ToggleButtonGroup>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  toggleButtonGroup: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    borderRadius: 4,
    boxShadow: theme.shadows[2]
  },

  error: {
    backgroundColor: theme.palette.primary.main,
    "& $toggleButton": {
      color: theme.palette.common.white
    }
  },

  toggleButton: {
    width: "100%",
    color: theme.palette.primary.dark
  }
}));
